import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  text: 'El checklist de valoración y la tabla de señales de alarma me cambiaron la forma de estudiar. Antes memorizaba datos, ahora sé qué mirar primero y por qué.',
  initial: 'C',
  name: 'Camila R.',
  role: 'Estudiante de 4° año'
}, {
  text: 'Los casos clínicos del Tomo 6 me ayudaron a conectar la teoría con situaciones reales del hospital. Lo recomiendo a cualquiera que esté entrando al internado.',
  initial: 'M',
  name: 'Martín L.',
  role: 'Enfermero junior'
}, {
  text: 'La parte de farmacología y cálculos era lo que más me costaba. Con el Tomo 5 y la guía de medicación lo pude ordenar por primera vez.',
  initial: 'P',
  name: 'Paula A.',
  role: 'Estudiante avanzada'
}];
export function Testimonials() {
  return <section className="py-10 md:py-16 bg-clinical-mist" data-id="element-185" data-mp="qalipwygt5tf">
      <div className="max-w-[1140px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186" data-mp="qb51tgzuq091">
        <div className="text-center max-w-2xl mx-auto mb-6 md:mb-9" data-id="element-187" data-mp="h4wva3k7seiq">
          <p className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-2.5" data-id="element-188" data-mp="m4rmk87wj64b">
            Testimonios
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-clinical-deep leading-[1.08] uppercase" data-id="element-189" data-mp="79bo7r0ago24">
            Estudiantes y profesionales{' '}
            <span className="accent-italic normal-case" data-id="element-190" data-mp="zvwh4vwex87s">que ya lo usan</span>
          </h2>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-191" data-mp="14vskcsxacvma">
          {TESTIMONIALS.map((testimonial, idx) => <motion.li key={testimonial.name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          delay: Math.min(idx * 0.05, 0.15),
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col bg-white rounded-2xl p-5 border border-clinical-line/70" data-id="element-192" data-mp="q63eike903fo" data-mpi={idx}>
              <div className="flex gap-0.5 mb-3" data-id="element-193" data-mp="1oj5j23px6vxz">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-clinical-accent text-clinical-accent" data-id="element-194" data-mp="1jkkjm6ihsgal" data-mpi={i} />)}
              </div>

              <p className="text-[14px] text-clinical-ink leading-relaxed mb-4 flex-grow" data-id="element-195" data-mp="19qlfj1yuymg0">
                “{testimonial.text}”
              </p>

              <div className="flex items-center gap-3 mt-auto pt-3 border-t border-clinical-line/70" data-id="element-196" data-mp="10sroa5fyaizp">
                <span className="w-9 h-9 rounded-full bg-clinical-mist text-clinical-deep font-bold text-sm flex items-center justify-center flex-shrink-0" data-id="element-197" data-mp="vrlt80ytijn0">
                  {testimonial.initial}
                </span>
                <span className="leading-tight" data-id="element-198" data-mp="32ge4r9sddi0a">
                  <span className="block font-bold text-clinical-deep text-[13px]" data-id="element-199" data-mp="37fqqtsbf2l1t">
                    {testimonial.name}
                  </span>
                  <span className="block text-[11px] text-clinical-ink/60" data-id="element-200" data-mp="3cflhbura58mc">
                    {testimonial.role}
                  </span>
                </span>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}